export default {
  props: ['loading', 'config'],
  data: () => ({
    local_config: {},
    local_loading: false
  }),
  watch: {
    config(){
      this.local_loading = true
      this.local_config = JSON.parse(JSON.stringify(this.config)) //Object.assign({}, this.config) //{...this.config}
      this.local_loading = false
    }
  },
  methods: {
    submit() {
      this.validate()
      return JSON.parse(JSON.stringify(this.local_config)) //Object.assign({} ,this.local_config) //{...this.local_config}
    },
    validate() {
      throw new Error('Validation should be overriden')
    }
  },
  computed: {
    rules(){
      return {
        ipaddr: (value) => {
          return value ? value.match(/^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/) === null ? this.$t('IP адрес должен удовлетворять маске xxx.xxx.xxx.xxx') : true : this.$t('Это обязательное поле')
        },
        ipaddrzeroes: (value) => {
          return value ? value.match(/^(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/) === null ? this.$t('IP адрес должен удовлетворять маске xxx.xxx.xxx.xxx') : true : this.$t('Это обязательное поле')
        },
        port: (value) => {
          return this.rules.inrange(1, 65535)(value)
          // return value ? isNaN(+value) ? this.$t('Требуется число') : +value <= 0 || +value > 65535 ? this.$t('Требуется число от 1 до 65535') : true : this.$t('Это обязательное поле')
        },
        require: (value) => {
          return value ? true : this.$t('Это обязательное поле')
        },
        inrange: (min, max) => {
          return (value) => {
            return value ? isNaN(+value) ? this.$t('Требуется число') : +value < min || +value > max ? `${this.$t('Требуется число в диапазоне')} ${min}...${max}` : true : this.$t('Это обязательное поле')
          }
        },
        minlen: (len) => {
          return (value) => value?.length >= len ? true : `${this.$t('Минимальная длина')} - ${len}`
        }
      }
    },
    any_loading(){
      return this.loading || this.local_loading
    }
  },
  // mounted(){
  //   this.local_loading = true
  //   this.local_config = JSON.parse(JSON.stringify(this.config)) //Object.assign({}, this.config) //{...this.config}
  //   this.local_loading = false
  // },
  beforeMount(){
    this.local_loading = true
    this.local_config = JSON.parse(JSON.stringify(this.config)) //Object.assign({}, this.config) //{...this.config}
    this.local_loading = false
  }
}